import { gql } from "apollo-boost";
import { idtype, relatedArticleImage } from "querypieces";

export default gql`
    query($relatedTo:[QueryArgument], $limit:Int) {
        entries(section: "blog", relatedTo: $relatedTo, limit: $limit) {
            ${idtype}
            ... on blog_Entry {
              id
              altText
              articleType
              ${relatedArticleImage}
              blogPostHeaderMatrix {
                ... on blogPostHeading_Entry {
                  ${idtype}
                  header
                  publisher
                  date
                  authors
                }
              }
              uri
            }
            ... on externalPost_Entry {
              ${idtype}
              altText
              articleType
              externalUrl {
                url
              }
              blogPostHeaderMatrix {
                ... on blogPostHeading_Entry {
                  ${idtype}
                  date
                  authors
                  header
                  publisher
                }
              }
              ${relatedArticleImage}
            }
        }
    }
`;



